export const getLanguage = () => {
  const language = localStorage.getItem('language');
  return language === 'SE' ? 'sv' : 'en';
};
